<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#" @click="$emit('onSelectRefreshState')"
        >NextFarm</a
      >
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link active" :to="{ name: 'dashboard' }">
              Dashboard
            </router-link>
          </li>
          <div class="btn-group">
            <button
              type="button"
              class="btn shadow-none"
              :disabled="!this.$store.getters.currentFarmId"
              @click.prevent="
                this.$router.push({
                  name: 'farm',
                  params: { id: this.$store.getters.currentFarmId },
                })
              "
            >
              {{ this.$store.getters?.currentFarmName ?? "Farm" }}
            </button>
            <button
              type="button"
              class="btn dropdown-toggle dropdown-toggle-split"
              data-bs-toggle="dropdown"
            >
              <span class="visually-hidden">Toggle Dropdown</span>
            </button>
            <ul class="dropdown-menu">
              <li
                v-for="(farm, id) in this.$store.getters.farms"
                :key="id"
                :name="farm.name"
              >
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="
                    this.$router.push({
                      name: 'farm',
                      params: { id: id },
                    })
                  "
                  >{{ farm.name }}</a
                >
              </li>
            </ul>
          </div>
        </ul>
        <div
          class="spinner-border mx-3"
          role="status"
          v-show="status === 'pending'"
        />
        <form class="d-flex" @submit.prevent="logout">
          <button class="btn btn-outline-success" type="submit">Logout</button>
        </form>
      </div>
    </div>
  </nav>
</template>

<script>
import { computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  emits: ["onSelectRefreshState"],

  setup() {
    const store = useStore();
    const router = useRouter();

    const status = computed(() => store.getters.status);

    const logout = async () => {
      try {
        await store.dispatch("logout");
        router.push("/");
      } catch (err) {
        console.log(err);
      }
    };

    return {
      status,
      logout,
    };
  },
};
</script>
